 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"35ee3136f34c977d34951bbcb0d6ff16685bb308","2":"e1d1eaa655c0dc7ef8c376e4fe2db3b7874086e8","3":"90e738f89d8d5a1378e85677c5db181849e5106c","4":"8d81505522d4bb4b790ec7162235f0b8fe2df361","5":"030036a7b4bb7f9359d1307a56f855f5ab335aaf","6":"464ddf60f2fbea6541c56457c2c6c7764f34b369","7":"238b9414b650a230a5cb79ea81b69982e281a682","8":"d90a98c9c4bdc80eafd1863ba0a874ca31dbcea7","9":"f6f49f9212dc1a58c382448191ac1156db60ba88","10":"2a14374a19e9b590e4bec1fd6cce9fe882adcc20","11":"595581ed0e0d5bd041f9eb3f9ba07281fed30560","12":"707e0e5cfa85d6335296e09deac1307d6d34f3e2","13":"fbeae90ceedb704168ea454ce62ef4080d70b6cb","15":"1bfc9850","16":"4a3ea9cd","18":"component---src-pages-404-js","19":"component---src-pages-about-js","20":"component---src-pages-aphorisms-js","21":"component---src-pages-architecture-js","22":"component---src-pages-epiphany-js","23":"component---src-pages-full-map-js","24":"component---src-pages-hunt-js","25":"component---src-pages-index-js","26":"component---src-pages-lerner-js","27":"component---src-pages-looking-at-what-you-cannot-see-js","28":"component---src-pages-notation-js","29":"component---src-pages-notation-test-rn-js","30":"component---src-pages-notation-test-rng-js","31":"component---src-pages-notation-types-js","32":"component---src-pages-poetry-js","33":"component---src-pages-pragma-js","34":"component---src-pages-table-of-contents-js","35":"component---src-pages-using-typescript-tsx","36":"component---src-pages-vaccinate-js","37":"component---src-pages-work-js","38":"component---src-pages-writing-js","39":"component---src-templates-blog-post-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"35475c97a9e0c9e5b3dc","2":"9e691a69f724b0a1af1c","3":"ef790290026aec2a4387","4":"d1d6a09c8c5bce332e9f","5":"d0fb3013d3e7af0b6d31","6":"b6f3f0e15813417458e9","7":"de11e1af8d64b745bca7","8":"6bde1a4487e3b73ac6cd","9":"170f8331b042b3125e01","10":"c1a188f40134941566f5","11":"e8efd61551f45ea40fd7","12":"79b6e4d70bfd2e15d446","13":"fad00625ed1bb32d0add","15":"5cf869877559eb38e35a","16":"ac5690bc988de47d55af","18":"4c0f09ba1cc399ee1ecf","19":"5920c1282259b883bfed","20":"b5987898feaced3e3ddb","21":"231c3c5081fee5404033","22":"9401c802841c3ab03951","23":"d950e0eb0c720b19a995","24":"08a494a9933aed3a833b","25":"73e55e6e6eaaeb555001","26":"7e5935c7c1a4e2168511","27":"bfa5986c7b355701a380","28":"4b8751b9f4d097e23a59","29":"07a393ad3eba2b19f6a7","30":"5254764a5185fa807a6f","31":"f3c927f49a858792d8d9","32":"4c5cf98679b4119081e4","33":"d6fc0f7624f73dcbb593","34":"452a31c8ec39f61db67c","35":"f2295f319cf37c3a9b4d","36":"911ea4bfdf4a1d34019e","37":"5bd8797ce4b56061e9ef","38":"55b9249c8bcd742db633","39":"0fe1230e6aa787fd1eb8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"35ee3136f34c977d34951bbcb0d6ff16685bb308","2":"e1d1eaa655c0dc7ef8c376e4fe2db3b7874086e8","3":"90e738f89d8d5a1378e85677c5db181849e5106c","4":"8d81505522d4bb4b790ec7162235f0b8fe2df361","5":"030036a7b4bb7f9359d1307a56f855f5ab335aaf","6":"464ddf60f2fbea6541c56457c2c6c7764f34b369","7":"238b9414b650a230a5cb79ea81b69982e281a682","8":"d90a98c9c4bdc80eafd1863ba0a874ca31dbcea7","9":"f6f49f9212dc1a58c382448191ac1156db60ba88","10":"2a14374a19e9b590e4bec1fd6cce9fe882adcc20","11":"595581ed0e0d5bd041f9eb3f9ba07281fed30560","12":"707e0e5cfa85d6335296e09deac1307d6d34f3e2","13":"fbeae90ceedb704168ea454ce62ef4080d70b6cb","15":"1bfc9850","16":"4a3ea9cd","18":"component---src-pages-404-js","19":"component---src-pages-about-js","20":"component---src-pages-aphorisms-js","21":"component---src-pages-architecture-js","22":"component---src-pages-epiphany-js","23":"component---src-pages-full-map-js","24":"component---src-pages-hunt-js","25":"component---src-pages-index-js","26":"component---src-pages-lerner-js","27":"component---src-pages-looking-at-what-you-cannot-see-js","28":"component---src-pages-notation-js","29":"component---src-pages-notation-test-rn-js","30":"component---src-pages-notation-test-rng-js","31":"component---src-pages-notation-types-js","32":"component---src-pages-poetry-js","33":"component---src-pages-pragma-js","34":"component---src-pages-table-of-contents-js","35":"component---src-pages-using-typescript-tsx","36":"component---src-pages-vaccinate-js","37":"component---src-pages-work-js","38":"component---src-pages-writing-js","39":"component---src-templates-blog-post-js"}[chunkId]||chunkId) + "." + {"0":"903647c44bb37ce19356","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
